var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskTreetment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.736 5.53127C15.7256 5.4111 15.4574 5.18031 15.3439 5.13915C15.2301 5.09773 15.1027 5.12592 15.0171 5.21107L13.2999 6.92826L11.0695 4.6978L12.821 2.95284C12.9067 2.86753 12.9347 2.7406 12.8934 2.62743C12.8517 2.51404 12.5767 2.27381 12.4558 2.2634C11.3921 2.1721 10.3498 2.55046 9.59622 3.3013C8.56414 4.32958 8.29083 5.83116 8.77481 7.11107C8.72191 7.15547 8.66972 7.20252 8.61823 7.25325L2.77153 12.7495C2.76947 12.7515 2.76744 12.7537 2.76521 12.7556C2.07761 13.4407 2.07761 14.5553 2.76521 15.2404C3.45291 15.9254 4.56354 15.9171 5.25102 15.232C5.25398 15.2293 5.25669 15.2265 5.25941 15.2235L10.7283 9.35342C10.7781 9.30353 10.8244 9.25134 10.8681 9.19776C12.1532 9.6808 13.6614 9.40916 14.6944 8.3802C15.4478 7.6293 15.8278 6.59087 15.736 5.53127Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskTreetment);
export default __webpack_public_path__ + "static/media/IconRiskTreetment.92fc7361860d22a61c02b09bec8515ef.svg";
export { ForwardRef as ReactComponent };